// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__6pez1","list":"BalanceDue_list__1q9iX","listRow":"BalanceDue_listRow__3LX-o","total":"BalanceDue_total__1acFw"};